export let ribbonAddressBookLabel = "ZNjgRb";
export let ribbonAddressBookTooltip = "k7sCs";
export default {ribbonAddressBookLabel,ribbonAddressBookTooltip};